import React from "react";
import classnames from "classnames";
import styles from "./SelectProviderUserForGames.scss"
import map from "lodash/map";

export default function SelectProviderUserFormGames({
	onUserSelected,
	users = [],
}) {

	if (users.length > 1) return null;

	return (
		<div className={classnames(styles.root, "margin-md")}>
			<h2 className="text-center">Select a User</h2>
			<div className="flex justify-flex-center flex-wrap">
				{map(users, user => (
					<div
						className={classnames(styles.userTiles, "flex-none flex justify-flex-center align-center margin-x-sm")}
						onClick={() => onUserSelected(user)}
					>
						{user.firstName} {user.lastName}
					</div>
				))}
			</div>
		</div>
	)
}